import { render, staticRenderFns } from "./ElemLook.vue?vue&type=template&id=27160b5e&"
import script from "./ElemLook.vue?vue&type=script&lang=js&"
export * from "./ElemLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports